import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions
} from "@tanstack/react-query";

import {
  PostWidgetAnalysisConfigPayload,
  PostWidgetAnalysisResponse,
  PostWidgetDefaultConfigResponse
} from "@/types/widget";

import { postWidgetAnalysisConfig, postWidgetDefaultConfig } from "./widgetAPI";

export const useGetWidgetAnalysisConfig = (
  payload: PostWidgetAnalysisConfigPayload,
  options?: Omit<
    UseQueryOptions<PostWidgetAnalysisResponse, Error>,
    "queryKey" | "queryFn"
  >
) =>
  useQuery({
    queryKey: ["widgetAnalysis", payload],
    queryFn: () => postWidgetAnalysisConfig(payload),
    ...options
  });

export const useMutateGetWidgetDefaultConfig = (
  options?: Omit<
    UseMutationOptions<PostWidgetDefaultConfigResponse, Error, string>,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation({
    mutationKey: ["widgetDefaultConfig"],
    mutationFn: (id: string) => postWidgetDefaultConfig(id),
    ...options
  });

export const useQueryGetWidgetDefaultConfig = (
  id: string,
  options?: Omit<
    UseQueryOptions<PostWidgetDefaultConfigResponse, Error>,
    "queryKey" | "queryFn"
  >
) =>
  useQuery({
    queryKey: ["widgetDefaultConfig", id],
    queryFn: () => postWidgetDefaultConfig(id),
    ...options
  });
